/*LIBRARY*/
import { useCallback, useMemo } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";
import {
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
} from "../../App/actions/dataActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const LEGEND_TEXT = ({
  auth,
  layer,
  filter_isi_layer,
  undo_filter_isi_layer,
  reset_filter,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { geo_layer_list, layer_id } = layer;

  //content
  const layer_data = useMemo(() => {
    return geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
      ?.geo_layer;
  }, [geo_layer_list, layer_id]);

  const features = layer_data?.geojson?.features || [];

  const style_array = layer_data?.style_array || [];
  const default_style_key = layer_data?.default_style_key || "";
  const style_object = style_array.find(
    (item) => item.key === default_style_key
  );

  const style_type = style_object?.style_type;
  const paint_object = style_object?.paint_object || {};
  const field_key = style_object?.field_key;

  const fields = useMemo(() => {
    return layer_data?.fields || [];
  }, [layer_data?.fields]);

  const field = fields.find((f) => f.key === field_key);
  const array_value_filter = field?.array_value_filter || [];

  let color_key;
  if (style_type === "circle") {
    color_key = "circle-color";
  } else if (style_type === "line") {
    color_key = "line-color";
  } else if (style_type === "fill") {
    color_key = "fill-color";
  }

  const insight_object = layer_data?.insight_object || {};
  const is_insight = insight_object?.is_insight || false;

  const array = paint_object?.[color_key] || [];

  const on_filter_isi_layer = useCallback(
    (field_key, value) => {
      const field = fields.find((f) => f.key === field_key);
      const array_value_filter = field?.array_value_filter || [];

      const body = {
        geo_layer_id: layer_id,
        field_key,
        value,
      };

      if (array_value_filter.includes(value)) {
        undo_filter_isi_layer(body);
      } else {
        filter_isi_layer(body);
      }
    },
    [fields, filter_isi_layer, undo_filter_isi_layer, layer_id]
  );

  const on_reset_filter = useCallback(() => {
    const body = { geo_layer_id: layer_id };
    reset_filter(body);
  }, [reset_filter, layer_id]);

  const content = (
    <main style={{ maxHeight: "250px", overflowY: "auto" }}>
      <button
        className="button background_black margin_bottom"
        onClick={on_reset_filter}
        data-mapid="clickReset"
      >
        Reset
      </button>
      {features.length > 0 && array.length > 0 && (
        <table>
          <tbody>
            {array.map((item, idx) => {
              if (idx < 2) return null;
              if (idx % 2 === 0 && idx < array.length - 1) {
                let value = item;
                if (is_insight) {
                  value = dict?.[item]?.[language];
                }

                return (
                  <tr
                    key={idx}
                    onClick={() => on_filter_isi_layer(field_key, item)}
                    className="cursor_pointer"
                  >
                    <td style={{ width: "20px", verticalAlign: "middle" }}>
                      <button
                        className={
                          array_value_filter.includes(item)
                            ? "checklist_active"
                            : "checklist_not"
                        }
                        data-mapid={`clickFilter-${idx}`}
                      />
                    </td>
                    <td style={{ width: "20px", verticalAlign: "middle" }}>
                      <div
                        style={{
                          backgroundColor: array[idx + 1],
                          width: "20px",
                          height: "20px",
                          border: "1px solid black",
                        }}
                      ></div>
                    </td>
                    <td>
                      <p
                        className="text_small"
                        style={{
                          maxWidth: "100px",
                          maxHeight: "1.2em",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {value}
                      </p>
                    </td>
                  </tr>
                );
              } else {
                return null;
              }
            })}
          </tbody>
        </table>
      )}
    </main>
  );

  return <main>{content}</main>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  set_value_properties,
  status_action,
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
})(LEGEND_TEXT);
